import { Navigate } from "react-router-dom";
import AuthLayout from "../layouts/AuthLayout";
import SignIn from "../pages/SignIn";
import SignUp from "../pages/SignUp";
import EmailVerification from "../pages/EmailVerication";
import EmailVerificationCode from "../pages/EmailVerificationCode";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import GuestRoute from "@/shared/components/guards/GuestRoute";

const authRoutes = {
  path: "/",
  element: (
    <GuestRoute>
      <AuthLayout />
    </GuestRoute>
  ),
  children: [
    {
      index: true,
      element: <Navigate to="sign-in" replace />,
    },
    {
      path: "sign-in",
      element: <SignIn />,
    },
    {
      path: "sign-up",
      element: <SignUp />,
    },
    {
      path: "email-verification",
      element: <EmailVerification />,
    },
    {
      path: "email-verification-code",
      element: <EmailVerificationCode />,
    },
    {
      path: "forgot-password",
      element: <ForgotPassword />,
    },
    {
      path: "reset-password",
      element: <ResetPassword />,
    },
  ],
};

export default authRoutes;
